<template>
  <div
    class="z-datepicker-wrapper"
    :class="{ 'has-value': hasValue }"
    :data-datepicker-id="uniqueId"
    @click="handleClick"
  >
    <label v-if="label" class="z-datepicker-label">{{ label }}</label>
    <Datepicker
      ref="datepickerRef"
      :model-value="modelValue"
      v-bind="$attrs"
      :placeholder="hasValue ? ' ' : placeholder"
      :uid="uniqueId"
      @update:model-value="handleUpdate"
      @open="handleOpen"
      @closed="handleClose"
    />
  </div>
</template>

<script>
import Datepicker from '@vuepic/vue-datepicker';

export default {
  name: 'ZDatepicker',

  components: {
    Datepicker,
  },

  props: {
    modelValue: {
      type: [Date, String, null],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },

  emits: ['update:modelValue', 'open', 'closed'],

  data() {
    return {
      uniqueId: `z-datepicker-${crypto.randomUUID()}`,
    };
  },

  computed: {
    hasValue() {
      return this.modelValue != null && this.modelValue !== '';
    },
  },

  methods: {
    handleUpdate(value) {
      this.$emit('update:modelValue', value);
    },

    handleOpen(event) {
      this.$emit('open', event);
    },

    handleClose(event) {
      this.$emit('closed', event);
    },

    handleClick(event) {
      // Only handle clicks on the wrapper itself, not on the datepicker's internal clear button
      if (event.target.closest('.dp__clear_icon')) {
        return; // Let the clear button work normally
      }

      // Open the menu programmatically
      if (this.$refs.datepickerRef?.openMenu) {
        this.$refs.datepickerRef.openMenu();
      }
    },

    openMenu() {
      if (this.$refs.datepickerRef?.openMenu) {
        this.$refs.datepickerRef.openMenu();
      }
    },
  },
};
</script>

<style scoped lang="sass">
.z-datepicker-wrapper
  position: relative
  width: 100%
  cursor: pointer

  .z-datepicker-label
    position: absolute
    left: 16px
    top: 50%
    transform: translateY(-50%)
    font-size: 16px
    color: rgba(0, 0, 0, 0.38)
    background: transparent
    padding: 0
    z-index: 1
    pointer-events: none
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1)
    opacity: 0
    visibility: hidden

  &.has-value .z-datepicker-label
    opacity: 1
    visibility: visible
    top: 8px
    transform: translateY(0)
    font-size: 12px
    background: white
    padding: 0 4px
    left: 13px
    color: rgba(0, 0, 0, 0.6)

  &.has-value :deep(.dp__input_icon)
    top: 33px !important

  &.has-value :deep(.dp__input)
    padding-top: 20px !important
    padding-bottom: 8px !important

  :deep(.dp__input)
    padding-top: 14px !important
    padding-bottom: 14px !important

  :deep(.dp__input_wrap)
    cursor: pointer

  :deep(.dp__input)
    cursor: pointer
    pointer-events: none !important
    user-select: none

  :deep(.dp__clear_icon)
    pointer-events: auto !important
    cursor: pointer !important
    top: 28px !important
    z-index: 10

  :deep(.dp__input_icon)
    top: 27px !important
    left: 3px !important
    pointer-events: none !important
</style>
